import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { OfbizForm } from '@urbannex/ofbiz-forms';
import { ComponentConfig, SelectedValue } from '../shared/model';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { CustomContainerInterFace } from './custom-container-interface';
import { CustomContainerItem } from './custom-container-item';
import { CustomContainerDirective } from './custom-container.directive';

@Component({
  selector: 'ubs-custom-container',
  templateUrl: './custom-container.component.html',
  styleUrls: ['./custom-container.component.scss']
})
export class CustomContainerComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() addForm: OfbizForm;
  @Input() customView: string;
  @Input() action: string;
  @Input() selectedValue: SelectedValue;
  componentConfig: ComponentConfig;
  customContainerItems: CustomContainerItem[];
  currentComponent: any;


  @ViewChild(CustomContainerDirective, { static: false }) customContainerHost!: CustomContainerDirective;

  constructor(
    private componentStore: UbsComponentStoreService,
    private cdref: ChangeDetectorRef) { }

  ngOnInit(): void {
    /* this.componentStore.vm$.subscribe(data => {
      console.log({data:data});

      console.log({customContainerItems:this.customContainerItems});
      this.selectedValue = data["selectedValue"];
      if(this.selectedValue){
        let formData = this.selectedValue.data.formData;
        console.log("formData",formData);
        let formName = formData.formName;
      }
      }); */
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add '${implements OnChanges}' to the class.
    if (changes["customView"]) {
      this.componentStore.vm$.subscribe(data => {
        // console.log({data:data});
        // console.log({selectedValueFromStore:data.selectedValue});
        this.componentConfig = data.componentConfig;
        this.customContainerItems = this.componentConfig.customContainerItems;
        // console.log({customContainerItems:this.customContainerItems});
        const customContainerItem = this.customContainerItems.find(element => element.id == this.customView);
        this.currentComponent = customContainerItem.component;
        // console.log({currentComponent:this.currentComponent});
        // Put parameters into the context. Use the breacrumbs object
        const breadCrumbs = data.breadCrumbs;
        let parameters = null;
        if (data.action != null && data.action != undefined) {
          if (data.action == "add") {
            data.selectedValue = null;
          }
        }
        if (data.selectedValue != null || data.selectedValue != undefined) {
          console.log("I shouldnt fucking get here");
          /**
           * Add selected Value only if action = "edit"
           */
          this.currentComponent.data = { form: this.addForm, selectedValue: data.selectedValue, parameters: parameters, action: this.action };
        } else {
          console.log("No fucking selectedValue fucking get here");
          console.log({ breadCrumbs: breadCrumbs });
          if (breadCrumbs != undefined && breadCrumbs.length > 0) {
            const lastBreadCrumb = breadCrumbs[breadCrumbs.length - 1];
            console.log({ lastBreadCrumb: lastBreadCrumb });
            if (lastBreadCrumb != null) {
              const selectedValue = lastBreadCrumb.selectedValue;
              console.log({ breadCrumbSelectedValue: selectedValue });
              if (selectedValue != null || selectedValue != undefined) {
                console.log({ selectedValueChecked: selectedValue });
                if (this.action != "add") {
                  parameters = selectedValue.data.parameters;
                }
                this.currentComponent.data = { form: this.addForm, selectedValue: data.selectedValue, parameters: parameters, action: this.action };
                console.log({ componentDataPassedOn: this.currentComponent.data });
              }
            }
          }

        }
        // this.loadComponent(this.currentComponent);
      })

    }
  }
  ngAfterViewInit(): void {
    if (this.customContainerHost) {
      console.log(this.customContainerHost);
      if (!this.customView) {
        this.componentStore.vm$.subscribe(data => {
          this.componentConfig = data.componentConfig;
          if (this.componentConfig != undefined) {
            this.customContainerItems = this.componentConfig.customContainerItems;
            // console.log({customContainerItems:this.customContainerItems});
            const customContainerItem = this.customContainerItems[0];
            if (customContainerItem) {
              this.currentComponent = customContainerItem.component;
              if (customContainerItem.data) {
                this.currentComponent.data = customContainerItem.data;
              }
            }
          }
        })
      }
      this.loadComponent(this.currentComponent);
      this.cdref.detectChanges();
    }
  }
  loadComponent(currentComponent) {
    // const workBenchItem = currentComponent;
    // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(currentComponent);
    // console.log(componentFactory.componentType);
    console.log("ViewContainerRef updated")
    console.log(this.customContainerHost.viewContainerRef);
    const viewContainerRef = this.customContainerHost.viewContainerRef; // this.ngxWorkbench.viewContainerRef;
    // const componentRef = viewContainerRef.createComponent(componentFactory);
    const componentRef = viewContainerRef.createComponent(this.currentComponent);
    (<CustomContainerInterFace>componentRef.instance).data = currentComponent.data;
    componentRef.changeDetectorRef.detectChanges();
  }

}
